// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internal_server_error {
    display: flex;
    flex-basis: ;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 100vh;
}

.five_hundred_error {
    font-size: 150px;
    color: var(--admin-color);;
}

.five_hundred_error_message {
    color: red;
    font-size: 15px;
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/InternalServerErrorPage/InternalServerErrorPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".internal_server_error {\n    display: flex;\n    flex-basis: ;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n}\n\n.five_hundred_error {\n    font-size: 150px;\n    color: var(--admin-color);;\n}\n\n.five_hundred_error_message {\n    color: red;\n    font-size: 15px;\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
